
import { Component, Vue, Prop, Mixins, Watch } from 'vue-property-decorator'
import { TranslationHandler } from '../mixins/TranslationHandler'
import { Getter, Action } from 'vuex-class'
import Button from 'umg-components/src/components/atoms/Button.vue'
import Headline from 'umg-components/src/components/atoms/Headline.vue'
import Paragraph from 'umg-components/src/components/atoms/Paragraph.vue'
import AssetRadio from '../components/AssetRadio.vue'
import Services from '../components/Services.vue'
import HomeHow from '../components/HomeHow.vue'
import HomeDevice from '../components/HomeDevice.vue'
import LoginModal from '../components/LoginModal.vue'

@Component({
  components: {
    Button,
    Headline,
    AssetRadio,
    Services,
    Paragraph,
    HomeHow,
    HomeDevice,
    LoginModal,
  },
})
export default class Home extends Mixins(TranslationHandler) {
  @Getter visualPrimaryColor!: string
  @Getter visualIsDark!: boolean
  @Getter visualTextColor!: string
  @Getter visualButtonTextColor!: string
  @Getter visualFont!: string
  @Getter visualHideStartPageGraphs!: boolean
  @Getter visualRadioImageUrl!: string

  @Getter userIsSubscribed!: boolean

  @Getter partyLoginServices!: string[]
  @Getter partyLoginRequired!: boolean

  isModalOpen: boolean = false

  get translations() {
    return {
      intro: {
        title: this.$t('homeIntroTitle'),
        subtitle: this.$t('homeIntroSubtitle'),
        button: this.userIsSubscribed ? this.$t('homeIntroButtonConnected') : this.$t('homeIntroButton'),
      },
      preFooter: {
        button: this.userIsSubscribed ? this.$t('homeIntroButtonConnected') : this.$t('homeIntroButton'),
      },
    }
  }

  openServicePage() {
    if (this.userIsSubscribed) {
      this.$router.push({ name: 'Player' })
    } else if (!this.partyLoginRequired && this.partyLoginServices.length === 0) {
      // No login service is set, we can register wihout login
      this.$router.push({ name: 'Register' })
    } else if (this.partyLoginServices.length === 1) {
      this.openModal()
    } else {
      this.$router.push({ name: 'Service' })
    }
  }

  get preFooterBackground() {
    return this.visualIsDark ? '#202027' : this.visualPrimaryColor
  }

  openModal() {
    this.isModalOpen = true
  }

  closeModal() {
    this.isModalOpen = false
  }
}
